import type { MenuPopoverState } from "@fluentui/react-components";
import {
  makeStyles,
  mergeClasses,
  useMenuPopoverStyles_unstable,
  shorthands,
} from "@fluentui/react-components";
import { HighContrastSelector } from "@fluentui/react";
import { customTokens } from "@1js/acui-theme";

const useMenuPopoverContainerStyles = makeStyles({
  root: {
    ...shorthands.borderRadius("8px"),
    ...shorthands.padding("6px", "0px"),
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    maxWidth: "none",
    minWidth: "none",
    maxHeight:
      "calc(100vh - 50px)" /* The max height of the context menu should be the space available on the screen without the floatie(40px) and padding (~8px) */,
    backgroundColor: customTokens.colorNeutralBackground1,
    boxShadow: customTokens.shadow16,
  },
  highContrast: {
    [`${HighContrastSelector}`]: {
      ...shorthands.borderStyle("solid"),
    },
  },
});

export const useAppMenuPopoverStyles = (state: MenuPopoverState) => {
  const styles = useMenuPopoverContainerStyles();
  state.root.className = mergeClasses(
    styles.root,
    styles.highContrast,
    state.root.className
  );
  useMenuPopoverStyles_unstable(state);
  return state;
};
